import Flogo from '../Assets/FFlogo.png';
import Landingpic from '../Assets/Landing.png'
import HOBO from '../Assets/HOBO.png'
import SSIAP from '../Assets/SSIAP.png'
import SST from '../Assets/SST.png'
import APS from '../Assets/APS.png'
import DYNA from '../Assets/DYNA.png'
import OFD from '../Assets/OFD.png'
import GFSI from '../Assets/GFSI.png'
import FREGATE from '../Assets/fregate.png'
import Qualiopi from '../Assets/qualiopi.jpg';
import QualiopiPdf from '../Assets/CertificatQualiopi.pdf';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useState, Children, cloneElement } from 'react';
import "leaflet/dist/leaflet.css";
import { useEffect, useRef } from 'react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import localVideo from '../Assets/LogoVid.mp4';
import FotterDrop from './FotterDrop';



const Video = ({ src, alt, controls = true, ...props }) => {
    return (
      <video controls={controls} {...props}>
        <source src={src} type={`video/${src.split('.').pop()}`} />
        {alt} {/* Fallback text if video fails to load */}
      </video>
    );
  };


export const TheNav = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        if (window.location.hash) {
            const sectionId = window.location.hash.substring(1);
            const section = document.getElementById(sectionId);
            if (section) {
                setTimeout(() => {
                    section.scrollIntoView({ behavior: "smooth" });
                }, 100);
            }
        }

        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
        document.body.style.overflow = isOpen ? 'auto' : 'hidden';
    };

    const closeMenu = () => {
        setIsOpen(false);
        document.body.style.overflow = 'auto';
    };

    return (
        <>
            <nav className={`w-full h-[11vh] bg-white bg-opacity-85 flex justify-between md:pr-[100px] pr-9 pl-8 md:pl-[100px] items-center font-poppins font-semibold fixed top-0 left-0 z-50 transition-all duration-300 ${isScrolled ? 'shadow-md' : ''}`}>
                <a href="/" onClick={closeMenu}>
                    <img src={Flogo} alt="Logo Francillienne Formation" className='md:h-[10vh] h-[9vh]'/>
                </a>
                
                {/* Menu Desktop */}
                <div className='hidden lg:flex items-center lg:w-[40vw] w-[85vw] justify-between py-3'>
                    <a className="text-sm lg:text-base" href="/" onClick={closeMenu}>Accueil</a>
                    <a className="text-sm lg:text-base" href="/#Formations" onClick={closeMenu}>Formations</a>
                    <a className="text-sm lg:text-base" href="/#Statistiques" onClick={closeMenu}>Statistiques</a>
                    <a className="text-sm lg:text-base" href="/#Partenaires" onClick={closeMenu}>Partenaires</a>
                    <a className="text-sm lg:text-base" href="/contact" onClick={closeMenu}>Contact</a>
                </div>
                
                {/* Bouton Burger Mobile */}
                <button 
                    className="lg:hidden focus:outline-none"
                    onClick={toggleMenu}
                    aria-label="Menu"
                >
                    {isOpen ? (
                        <XMarkIcon className="h-8 w-8 text-black" />
                    ) : (
                        <Bars3Icon className="h-8 w-8 text-black" />
                    )}
                </button>
            </nav>

            {/* Menu Mobile */}
            <div className={`fixed inset-0 bg-black bg-opacity-90 z-40 transition-all duration-300 ease-in-out transform ${isOpen ? 'translate-x-0' : 'translate-x-full'} lg:hidden`}>
                <div className="flex flex-col items-center justify-center h-full space-y-8">
                    <a className="text-white text-2xl" href="/" onClick={closeMenu}>Accueil</a>
                    <a className="text-white text-2xl" href="/#Formations" onClick={closeMenu}>Formations</a>
                    <a className="text-white text-2xl" href="/#Statistiques" onClick={closeMenu}>Statistiques</a>
                    <a className="text-white text-2xl" href="/#Partenaires" onClick={closeMenu}>Partenaires</a>
                    <a className="text-white text-2xl" href="/contact" onClick={closeMenu}>Contact</a>
                </div>
            </div>
        </>
    );
};

export const Landing = () =>{
    return(
        <div className='sm:h-[102vh] h-[75vh] pt-[13vh] unid:px-[100px] sm:px-[50px] px-[25px] bg-[#111111] flex justify-between items-center'>
            <div className='flex justify-between flex-col items-start w-3/4 toomuch:w-full'>
                <div>
                    <h1 className='text-white font-extrabold undi:text-8xl lg:text-6xl text-3xl undi:leading-[6rem] lg:leading-[4rem] sm:leading-[2rem] leading-[2.5rem] font-times'> La Francilienne de<br/> la Formation</h1>
                    <p className='text-white undi:text-lg lg:text-xs text-[11px] undi:pr-20 sm:pr-16 pr-4 toomuch:pr-0'>Votre adresse de formation professionnelle en sécurité, secourisme et prévention des risques professionnels.</p>
                </div>
                <a href="/#Formations" className='undi:pl-9 pl-3 undi:pr-7 pr-2 undi:pt-2.5 pt-1 undi:pb-3 pb-1.5 flex justify-between items-end font-semibold undi:text-lg text-[10px] undi:mt-10 mt-6 undi:mb-10 mb-8 bg-white rounded-full'>Découvrir nos formations <ChevronRightIcon className="undi:h-6 h-3 text-black lg:ml-4 ml-1 stroke-[2px]" /> </a>
                <p className='text-white text-[7px] lg:text-xs pr-20 font-bold'>La Francilienne de la Formation Noisy le Grand</p>
                <p className='text-white text-[7px] lg:text-xs pr-20'>15 Rue de L’université, 93160, Noisy-le-Grand.</p>
                <p className='text-white text-[7px] lg:text-xs undi:pr-20 pr-5'>09.52.30.99.38 | direction.francilienne.formation@gmail.com</p>

                <p className='text-white text-[7px] lg:text-xs pr-20 font-bold mt-2'>La Francilienne de la Formation Rennes </p>
                <p className='text-white text-[7px] lg:text-xs pr-20'>41 rue Charles géniaux - 35000 Rennes. <span className='font-bold'>(Ouverture Prochaine)</span> </p>
                <p className='text-white text-[7px] lg:text-xs undi:pr-20 pr-5'>06.48.75.95.18| lffrennes@gmail.com</p>
            </div>
            <Video src={localVideo} autoPlay muted loop controls={false} alt="Logo Francillienne Formation" className='lg:h-[70vh] lg:w-[30vw] rounded-lg shadow-[0_0_20px_9px_rgba(255,255,255,0.2)] md:h-72 md:w-52 sm:h-64 sm:w-44 h-44 w-32 toomuch:invisible toomuch:w-0 object-cover'/>
        </div>
    );
}

export const NosFormations = () =>{
    return(
        <div id="Formations" className='h-fit pt-[14vh] md:pb-[8vh] pb-[3vh] md:px-[100px] px-[40px] flex flex-col justify-between items-center'>
            <h3 className='font-bold text-4xl mb-8 text-center font-times'>Nos formations Phares</h3>
            <div className='h-5/6 w-full flex justify-evenly items-center my-3 flex-wrap'>
                <a href='./SSIAP' className='h-[22rem] md:w-64 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-6 flex flex-col justify-around items-center my-3'>
                    <img src={SSIAP} alt="Photo SSIAP" className='w-48 h-48'/>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-xl text-center font-semibold font-times'>Formations incendie</h5>
                        <p className='text-center mt-1'>Devenez agent de sécurité incendie qualifié.</p>
                    </div>
                </a>
                <a href='./APS' className='h-[22rem] md:w-64 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-8 flex flex-col justify-around items-center my-3'>
                    <img src={APS} alt="Photo APS" className='w-48 h-48'/>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-xl text-center font-semibold font-times'>Formations APS</h5>
                        <p className='text-center mt-1'>Devenez agent de prévention et de sécurité.</p>
                    </div>
                </a>
                <a href='./SST' className='h-[22rem] md:w-64 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-8 flex flex-col justify-around items-center my-3'>
                    <img src={SST} alt="Photo SST" className='w-48 h-48'/>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-xl text-center font-semibold font-times'>Formation secourisme</h5>
                        <p className='text-center mt-1'>Sauveteur secouriste du Travail.</p>
                    </div>
                </a>
                <a href='./HOBO' className='h-[22rem] md:w-64 w-5/6 bg-[#F5F5F7] rounded-2xl p-4 flex flex-col justify-around items-center my-3'>
                    <img src={HOBO} alt="Photo HOBO" className='w-48 h-48'/>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-xl text-center font-semibold font-times'>Formation habilitation éléctrique</h5>
                        <p className='text-center mt-1'>Prévention des risques électriques.</p>
                    </div>
                </a>
            </div>
        </div>
    );
}

export const NosCertif = () =>{
    return(
        <div className='h-fit py-[4vh] my-2 md:px-[100px] px-[40px] flex flex-col justify-between items-center'>
            <h3 className='font-bold text-4xl mb-4 text-center font-times'>Nos Certifications</h3>
            <div className='flex flex-col justify-center items-center'>
                <p className='text-center mt-1'>Notre certification Qualiopi atteste de l’excellence et de la qualité de nos formations.</p>
                <a href={QualiopiPdf} target="_blank" rel="noopener noreferrer"><img src={Qualiopi} alt="Logo Qualipi" className='md:h-28 h-14 my-6'/></a>
                <a href={QualiopiPdf} target="_blank" rel="noopener noreferrer" className='text-center mt-1 flex justify-center items-center'>Consulter notre certification Qualiopi <ChevronRightIcon className="h-4 w-4 text-black stroke-[2px]" /></a>
            </div>
        </div>
    );
}


export const NosSol = () =>{
    return(
        <div className='h-fit my-4 py-[8vh] bg-[#111111] md:px-[100px] px-[50px] flex flex-col justify-between items-center'>
            <h3 className='font-bold md:text-4xl text-2xl text-white text-center font-times'>Qui sommes Nous ?</h3>
            <div className='flex flex-row items-start justify-start my-8'>
                <p className='text-white md:text-xl text-sm text-center'>La Francilienne de la Formation – Centre de formation à Noisy-le-Grand et Rennes
                La Francilienne de la Formation est un centre certifié QUALIOPI, spécialisé dans les formations en sécurité, secourisme et prévention des risques professionnels. Présents à Noisy-le-Grand et à Rennes, nous accompagnons particuliers et entreprises dans le développement de leurs compétences avec des programmes adaptés aux besoins du marché. Grâce à nos formateurs expérimentés et à notre pédagogie active, nous proposons des formations professionnalisantes de qualité reconnue.</p>
            </div>
            <a href="/Contact" className='undi:pl-9 pl-3 undi:pr-7 pr-2 undi:pt-2.5 pt-1.5 undi:pb-3 pb-2 flex justify-between items-end font-semibold undi:text-lg text-xs md:mt-4 mt-2 bg-[#D72427] text-white rounded-full'>Contactez-nous pour un devis <ChevronRightIcon className="undi:h-6 h-3 text-white lg:ml-4 ml-1 stroke-[2px]" /> </a>
        </div>
    );
}

export const Locations = () =>{
    return(
        <div className='h-fit py-[4vh] md:px-[100px] px-[50px] flex flex-col justify-between items-center'>
            <h3 className='font-bold text-4xl text-center mb-4 font-times'>Nos Localisations</h3>
            <div className='h-fit w-full flex justify-evenly items-center flex-wrap mt-2'>
                <div className="h-full md:w-[40vw] w-[80vw] flex flex-col justify-around items-center bg-[#F5F5F7] rounded-2xl p-2 my-3">
                    <iframe className='h-80 w-full rounded-xl' frameborder="0" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=15%20Rue%20de%20L%E2%80%99universit%C3%A9,%2093160,%20Noisy-le-Grand.+(Francilienne%20Formation)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/collections/drones/"></a></iframe>
                    <p className='px-2'>93160, Noisy le Grand</p>
                </div>
                <div className="h-full md:w-[40vw] w-[80vw] flex flex-col justify-around items-center bg-[#F5F5F7] rounded-2xl p-2 my-3">
                    <iframe className='h-80 w-full rounded-xl' frameborder="0"  marginheight="0" marginwidth="0" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5327.842109463435!2d-1.7138369000000002!3d48.111758599999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x480ee08bf2c6d0c9%3A0x457249afc00191b9!2s41%20Rue%20Charles%20G%C3%A9niaux%2C%2035000%20Rennes!5e0!3m2!1sfr!2sfr!4v1744268180793!5m2!1sfr!2sfr"><a href="https://www.gps.ie/collections/drones/"></a></iframe>
                    <p className='px-2'>35000, Rennes <span className='font-bold'>(Ouverture Prochaine)</span></p>
                </div>
            </div>
        </div>
    );
}

export const Fotter = () =>{
    return(
        <div className='h-fit mt-4 pt-[4vh] pb-[9vh] bg-[#111111] undi:px-[100px] px-[50px] flex justify-between items-center'>
            <div className='undi:w-[70vw] w-full bg-red h-full flex flex-col justify-between items-start'>
                <h3 className='font-bold md:text-4xl text-3xl text-white mb-3 font-times'>La Francilienne de la Formation.</h3>
                <div className='flex md:flex-row flex-col w-full justify-between items-center md:flex-nowrap flex-wrap h-fit'>
                    <div className='flex flex-col justify-between items-start pr-5 md:h-[38vh] h-[42vh] sm:w-1/2 w-full sm:mb-0 mb-16'>
                        <div className='h-[22vh] flex flex-col justify-evenly items-start'>
                            <p className='text-white text-base font-bold mb-1'>La Francilienne de la Formation Noisy le Grand</p>
                            <p className='text-white text-xs'>15 Rue de L’université, 93160, Noisy-le-Grand.</p>
                            <p className='text-white text-xs'>09.52.30.99.38</p>
                            <p className='text-white text-xs'>direction.francilienne.formation@gmail.com</p>

                            <p className='text-white text-sm md:mt-4 mt-2'>Agrément CNAPS : FOR-093-2026-09-29-20210785752</p>
                            <p className='text-white text-sm md:mb-4 mb-2'>Agrément SSIAP : 093-0054</p>

                            <p className='text-white text-base font-bold mb-1'>La Francilienne de la Formation Rennes</p>
                            <p className='text-white text-xs'>41 rue Charles géniaux, 35000, Rennes. <span className='font-bold'>(Ouverture Prochaine)</span></p>
                            <p className='text-white text-xs'>06.48.75.95.18</p>
                            <p className='text-white text-xs'>lffrennes@gmail.com</p>
                        </div>
                    </div>

                    <div className='h-[35vh] flex flex-col justify-between items-start sm:w-[60%] w-full sm:mt-0 pl-10 pr-3'>
                        <FotterDrop />
                        <a href="/Contact" className='undi:pl-9 pl-3 undi:pr-7 pr-2 undi:pt-2.5 pt-1.5 undi:pb-3 pb-2 flex justify-between items-end font-semibold undi:text-base text-xs mt-2 bg-[#D72427] text-white rounded-full'>Contactez-nous pour un devis <ChevronRightIcon className="undi:h-6 h-3 text-white lg:ml-4 ml-1 stroke-[2px]" /> </a>
                    </div>
                </div>
            </div>
            <a href="/">
                <img src={Flogo} alt="Logo Francilienne Formations" className='h-52 undi:visible invisible undi:w-fit w-0'/>
            </a>
        </div>
    );
}

export const Stats = () =>{
    return(
        <div id="Statistiques" className='h-fit pt-[14vh] md:pb-[3vh] md:px-[100px] px-[40px] flex flex-col justify-between items-center'>
            <h3 className='font-bold text-4xl mb-8 text-center font-times'>Nos Statistiques</h3>
            <div className='h-5/6 w-full flex justify-evenly items-center my-3 flex-wrap'>
                <div className='h-[10rem] md:w-64 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-6 flex flex-col justify-around items-center my-3'>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-6xl text-center font-bold my-3 flex justify-center items-end'>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="gold" viewBox="0 0 24 24" strokeWidth={1.5} stroke="gold" className="h-10 mb-1">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="gold" viewBox="0 0 24 24" strokeWidth={1.5} stroke="gold" className="h-10 mb-1">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="gold" viewBox="0 0 24 24" strokeWidth={1.5} stroke="gold" className="h-10 mb-1">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="gold" viewBox="0 0 24 24" strokeWidth={1.5} stroke="gold" className="h-10 mb-1">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="gold" viewBox="0 0 24 24" strokeWidth={1.5} stroke="gold" className="h-10 mb-1">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                            </svg>
                        </h5>
                        <p className='text-center mt-1'>Avis Google</p>
                    </div>
                </div>
                <div className='h-[10rem] md:w-64 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-6 flex flex-col justify-around items-center my-3'>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-6xl text-center font-bold mb-2'>97%</h5>
                        <p className='text-center mt-1'>Taux de réussite</p>
                    </div>
                </div>
                <div className='h-[10rem] md:w-64 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-6 flex flex-col justify-around items-center my-3'>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-6xl text-center font-bold mb-2'>99%</h5>
                        <p className='text-center mt-1'>Taux de satisfaction.</p>
                    </div>
                </div>
                <div className='h-[10rem] md:w-64 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-6 flex flex-col justify-around items-center my-3'>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-6xl text-center font-bold mb-3'>+200</h5>
                        <p className='text-center mt-1'>Personnes formés en 2023</p>
                    </div>
                </div>
            </div>
        </div>
    ); 
}

export const Slider = ({ children }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(3); // Default: 3 for desktop
  const sliderRef = useRef(null); // Ref to get container width
  const items = Children.toArray(children);

  useEffect(() => {
    const updateVisibleCards = () => {
      const width = window.innerWidth;
      if (width < 640) setVisibleCards(1); // Mobile: 1 card
      else if (width < 1024) setVisibleCards(2); // Tablet: 2 cards
      else setVisibleCards(3); // Desktop: 3 cards
    };

    updateVisibleCards();
    window.addEventListener("resize", updateVisibleCards);
    return () => window.removeEventListener("resize", updateVisibleCards);
  }, []);

  const totalSlides = Math.max(items.length - visibleCards + 1, 1); // Ensure last card is visible

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev >= totalSlides - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev <= 0 ? totalSlides - 1 : prev - 1));
  };

  return (
    <div
      id="Partenaires"
      className="relative w-[90vw] max-w-[1200px] overflow-hidden mx-auto px-5 pt-20 pb-12"
      ref={sliderRef}
    >
      <h3 className="font-bold text-4xl mb-8 text-center font-times">Nos Partenaires</h3>

      {/* Slides Container */}
      <div className="overflow-hidden">
        <div
          className="flex gap-4 transition-transform duration-500 ease-in-out"
          style={{
            transform: `translateX(-${currentIndex * (sliderRef.current?.offsetWidth / visibleCards) || 0}px)`,
          }}
        >
          {items.map((item, index) => (
            <div
              key={index}
              className="flex-shrink-0 px-2"
              style={{ width: `${100 / visibleCards}%` }} // Responsive width
            >
              {cloneElement(item, { className: `${item.props.className || ""} w-full` })}
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Arrows */}
      {items.length > visibleCards && (
        <>
          <button
            onClick={prevSlide}
            className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/30 text-white p-2 rounded-full z-10 hover:bg-black/50"
          >
            ❮
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/30 text-white p-2 rounded-full z-10 hover:bg-black/50"
          >
            ❯
          </button>
        </>
      )}

      {/* Dots Indicator */}
      <div className="flex justify-center mt-4 gap-2">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2 h-2 rounded-full transition-all ${
              currentIndex === index ? "bg-blue-500 w-4" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export const Home = () =>{
    return(
        <>
            <TheNav/>
            <Landing/>
            <NosFormations/>
            <NosSol/>
            <Stats/>
            <Slider visibleCards={2}>
                {/* Card 1 */}
                <div className='h-[22rem] md:w-80 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-6 flex flex-col justify-around items-center my-3 mx-3'>
                    <img src={GFSI} alt="Photo SSIAP" className='w-48 h-48'/>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-xl text-center font-semibold px-3 font-times'>GFSI prévention et dissuasion</h5>
                    </div>
                </div>
                <div className='h-[22rem] md:w-80 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-6 flex flex-col justify-around items-center my-3 mx-3'>
                    <img src={DYNA} alt="Photo SSIAP" className='w-52 h-48'/>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-xl text-center font-semibold px-3 font-times'>Centre de formation DynaFormation</h5>
                    </div>
                </div>
                <div className='h-[22rem] md:w-80 w-5/6 bg-[#F5F5F7] rounded-2xl p-2 py-6 flex flex-col justify-around items-center my-3 mx-3'>
                    <img src={FREGATE} alt="Photo SSIAP" className='w-48 h-48'/>
                    <div className='flex flex-col items-center justify-center'>
                        <h5 className='text-xl text-center font-semibold px-3 font-times'>Fregate sécurité</h5>
                    </div>
                </div>
            </Slider>
            <NosCertif/>
            <Locations/>
            <Fotter/>
        </>
    );
}
